import React from 'react';
import './WhyChooseUs.css';

function WhyChooseUs() {
  return (
    <div className="why-choose-us">
      <h2>لماذا تختار شركتنا؟</h2>
      <p>
        تعاقدك مع شركة   تيما اكسبريس لنقل العفش والأثاث يمكن أن يوفر للعملاء مزايا كثيرة - هنا بعض الفوائد التي يمكن أن تتحقق عند التعاقد مع شركة   تيما اكسبريس لنقل العفش:
      </p>
      <ul>
        <li>
          <strong>تخفيضات كبيرة:</strong> عند التعاقد مع شركة   تيما اكسبريس لنقل العفش، يمكن الحصول على تخفيضات تصل إلى <strong>30%</strong> على الخدمات المقدمة. هذا يعني أن تكون تكاليف النقل أقل عند الحصول على الخدمات من شركة   تيما اكسبريس لنقل العفش.
        </li>
        <li>
          <strong>خدمة عالية الجودة:</strong> شركة   تيما اكسبريس لنقل العفش تقدم خدمات نقل عالية الجودة للعفش والأثاث. الشركة تعمل بجد وجهد على ضمان أن يتم تخزين ونقل الأثاث بشكل آمن ومريح للعميل.
        </li>
        <li>
          <strong>خدمة عملاء مميزة:</strong> شركة   تيما اكسبريس لنقل العفش تعتبر خدمة العملاء كأساس لنجاحها وتعمل على توفير خدمة عملاء مميزة للعملاء عند الحاجة.
        </li>
        <li>
          <strong>ضمان الأمان:</strong> شركة   تيما اكسبريس لنقل العفش تضمن أمان جميع الأثاث المخزنة والمنقولة عند التعاقد معها. سيتم تغطية الأثاث ضد التلف أو الخسارة عند الحاجة.
        </li>
      </ul>
    </div>
  );
}

export default WhyChooseUs;